import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../Redux";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";

const ApCreditNotes = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const financeAssetsData = useSelector(
    (state) => state?.financeReducer?.financeAssets
  );
  console.log(financeAssetsData, "financeAssetsData");
  const firstDateOfMonth =
    new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1;

  const initialData = {
    from_date: moment(firstDateOfMonth).format("yyyy-MM-DD"),
    to_date: moment(new Date()).format("yyyy-MM-DD"),
    // start_time: "12.00 am",
    // end_time: "12.00 pm",
  };
  const [startDate, setStartDate] = useState(moment(firstDateOfMonth).toDate());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState(initialData);

  useEffect(() => {
    dispatch(actions?.getFinanceAssets());
    return () => {
      dispatch(actions.saveFinanceValues({ financeAssetsData: null }));
    };
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row-fluid">
                  <div class="top-header-sec">
                    <div class="span12">
                      <h4 class="event-alert br-btm-0">
                        Assets
                        <div class="clear"></div>
                      </h4>
                      <div class="row-fluid">
                        <div class="span4">
                          <div class="search-box">
                            <form type="GET">
                              <input
                                type="text"
                                placeholder="Search"
                                name="search_table"
                                id="SavedSearchTag"
                              />
                            </form>
                          </div>
                        </div>
                        <div
                          class="span4 float-right"
                          onClick={() => {
                            console.log("pppppppppppppppppppp");
                            dispatch(actions?.downloadFinanceAssets());
                          }}
                        >
                          <div class="field text-right">
                            <button
                              id="download"
                              class="btn green-btn-revert download-icon"
                            >
                              <i class="i-icon"> </i> Download
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mx-10">
                  <div class="shadowclass top_filters orderpayy mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            <DatePicker
                              selected={startDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setStartDate(date);
                                setData({
                                  ...data,
                                  from_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                          <div class="datePicker pading_lect">
                            {/* <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div> */}
                            <DatePicker
                              selected={endDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setEndDate(date);
                                setData({
                                  ...data,
                                  to_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0 mt-md-3 mt-0 mt-lg-0 px-sm-2">
                        <MultiRangeSlider
                          min={0}
                          max={0}
                          symbol="$"
                          onChange={({ min, max }) => {
                            console.log(`min = ${min}, max = ${max}`);
                            setData({
                              ...data,
                              start_range: min,
                              end_range: max,
                            });
                          }}
                        />
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  type: e.target.value,
                                })
                              }
                            >
                              <option value="">Type</option>
                              {financeAssetsData?.asset_type?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                        <button
                          onClick={() => {
                            dispatch(actions?.getFinanceAssets(data));
                          }}
                          class="btn btn_btnblue"
                          type="submit"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        Assets Pending Completion
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    {financeAssetsData?.isShowLinkedData && (
                                      <th>Account</th>
                                    )}
                                    <th class="header">Asset ID</th>
                                    <th class="header">Asset Type</th>
                                    <th class="header">Asset Name</th>
                                    <th class="header">Quantity</th>
                                    <th class="header">Unit Value</th>
                                    <th class="header">Tax</th>
                                    <th class="header">Purchase Value</th>
                                    <th class="header">Purchase Date</th>
                                    <th class="header">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {financeAssetsData?.pending_assets?.map(
                                    (el, idx) => (
                                      <tr>
                                        {financeAssetsData?.isShowLinkedData && (
                                          <td>{el?.merchant?.account_name}</td>
                                        )}
                                        <td>{el?.payment?.transaction_ID}</td>
                                        <td>{el?.finance_account?.name}</td>

                                        <td>{el?.asset_account}</td>
                                        <td>{el?.quantity}</td>
                                        <td>
                                          {el?.current_balance / el?.quantity}
                                        </td>
                                        <td>{el?.tax}</td>
                                        <td>{el?.current_balance}</td>
                                        <td>
                                          {moment(el?.created).format(
                                            "MMM DD, YYYY"
                                          )}
                                        </td>

                                        <td>
                                          <a
                                            // onClick={() => {
                                            //   history.push(
                                            //     "/finance/payables/new-ap-credit-notes",
                                            //     {
                                            //       id: el?.id,
                                            //       pageType: "edit",
                                            //       view: false,
                                            //     }
                                            //   );
                                            // }}
                                            class="circle_icon"
                                          >
                                            <i class="iconSprites edit-icon"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">Asset Register</h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    {financeAssetsData?.isShowLinkedData && (
                                      <th>Account</th>
                                    )}
                                    <th class="header">Asset ID</th>
                                    <th class="header">Asset Type</th>
                                    <th class="header">Asset Name</th>
                                    <th class="header">Quantity</th>
                                    <th class="header">Current Value</th>
                                    <th class="header">
                                      Accum. <br />
                                      Depreciation
                                    </th>
                                    <th class="header">Purchase Value</th>
                                    <th class="header">Purchase Date</th>
                                    <th class="header">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {financeAssetsData?.register_asset?.map(
                                    (el, idx) => (
                                      <tr>
                                        {financeAssetsData?.isShowLinkedData && (
                                          <td>{el?.merchant?.account_name}</td>
                                        )}
                                        <td>{el?.payment?.transaction_ID}</td>
                                        <td>{el?.finance_account?.name}</td>

                                        <td>{el?.asset_account}</td>
                                        <td>{el?.quantity}</td>
                                        <td>{el?.current_balance}</td>
                                        <td>{el?.accum_apprec_deprec}</td>
                                        <td>{el?.current_balance}</td>
                                        <td>
                                          {moment(el?.created).format(
                                            "MMM DD, YYYY"
                                          )}
                                        </td>

                                        <td>
                                          <a
                                            // onClick={() => {
                                            //   history.push(
                                            //     "/finance/payables/new-ap-credit-notes",
                                            //     {
                                            //       id: el?.id,
                                            //       pageType: "edit",
                                            //       view: false,
                                            //     }
                                            //   );
                                            // }}
                                            class="circle_icon"
                                          >
                                            <i class="iconSprites edit-icon"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default ApCreditNotes;
